export { tracking as tracking };

var tracking = tracking || {
    adobe: {
        changeType: function (type) {
            if (tracking.adobe.adobeExists() === false) {
                return false;
            }

            if (type === 'TD') {
                window.digitalData.page.component.form.leadType = 'test-drive-request';
                window.digitalData.page.component.form.nameType = 'lead:test-drive-request';
            } else {
                window.digitalData.page.component.form.leadType = 'quote-request';
                window.digitalData.page.component.form.nameType = 'lead:quote-request';
            }
            if (dev_tracking === true) {
                console.log('Change selected form type')
            }
        },
        changeModelForForm: function (type, vehicleID, VehicleName, vehicleModelName, vehicleEngine, vehicleTrim) {
            if (tracking.adobe.adobeExists() === false) {
                return false;
            }
            window.digitalData.page.pageInfo.vehicleID = vehicleID;
            window.digitalData.page.pageInfo.vehicleModel = VehicleName;
            window.digitalData.page.pageInfo.vehicleModelName = vehicleModelName;
            window.digitalData.page.pageInfo.vehicleEngine = vehicleEngine;
            window.digitalData.page.pageInfo.vehicleTrim = vehicleTrim;

            if (type === 'TD') {
                window.digitalData.page.component.form.leadType = 'test-drive-request';
                window.digitalData.page.component.form.nameType = 'lead:test-drive-request';
            } else {
                window.digitalData.page.component.form.leadType = 'quote-request';
                window.digitalData.page.component.form.nameType = 'lead:quote-request';
            }
            if (dev_tracking === true) {
                console.log('Change selected model data')
            }
        },
        formSubmit: function (local_lead_id) {
            if (tracking.adobe.adobeExists() === false) {
                return false;
            }
            window.digitalData.page.component.form.transactionID = 'CCPOL' + local_lead_id;
            window.digitalData.page.component.form.stepName = 'thankyou-end';
            window._satellite.track('formsteps');

            if (dev_tracking === true) {
                console.log('Form submit and run aTrack')
            }
        },
        adobeExists: function () {
            if (typeof window.digitalData === 'undefined') {
                return false;
            }
            return typeof window._satellite !== 'undefined';
        },
        changeFinancing: function (name) {
            if (tracking.adobe.adobeExists() === false) {
                return false;
            }
            if (name === 'leasing') {
                digitalData.page.pageInfo.pageName = 'fiat-professional:pl:financial-offer:leasing';
                digitalData.page.category.subCategory2 = 'fiat-professional:pl:financial-offer:leasing';
                window.digitalData.page.pageInfo.mktgCampaignID = '13832';
            } else {
                digitalData.page.pageInfo.pageName = 'fiat-professional:pl:financial-offer:long-term';
                digitalData.page.category.subCategory2 = 'fiat-professional:pl:financial-offer:long-term';
                window.digitalData.page.pageInfo.mktgCampaignID = '12877';
            }

            if (dev_tracking === true) {
                console.log('Change financing', name);
            }
        }
    },
    init: function () {
        // first_cal_load = false;
    }
};

document.tracking = tracking;
